import { render, staticRenderFns } from "./DeviceTableRow.vue?vue&type=template&id=58a301b6&"
import script from "./DeviceTableRow.vue?vue&type=script&lang=js&"
export * from "./DeviceTableRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports